const sanitize = (inputText: string) => {
  return inputText.toLowerCase().split(' ').join('_');
};

export { sanitize };
